var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{attrs:{"match-heigth":""}},[_c('b-col',{attrs:{"cols":"12","md":"8"}},[_c('b-card',[_c('project-select'),_c('keyword-tags')],1)],1),_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('image-card')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }